<div class="row">
    <div class="col-12 col-md-6">

        <!-- Transaction Info -->
        <div class="page-section">
            <div class="page-section-header">
                <h2 class="page-section-title">Claim Unknown Payment</h2>
            </div>
            <div class="page-section-body">
                <table class="table">
                    <tbody>
                        <tr><th>Bank Name</th><td>{{transaction.bank_title}}</td></tr>
                        <tr><th>Received</th><td>{{transaction.debit}}</td></tr>
                        <tr><th>Received On</th><td>{{transaction.timestamp | date: 'short'}}</td></tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Search Player -->
        <div class="page-section">
            <div class="page-section-header">
                <h2 class="page-section-title">Search Player</h2>
            </div>
            <div class="page-section-filters">
                <form #f="ngForm" (submit)="search()" class="d-flex flex-wrap align-items-start gap-2 w-100">
                    <input type="text" class="form-control form-control-sm" style="max-width: 150px;" id="code" name="code"
                        #code="ngModel" [(ngModel)]="data.code" placeholder="Player Code" minlength="3" autocomplete="off" />
                    <input type="text" class="form-control form-control-sm" style="max-width: 150px;" id="name" name="name"
                        #name="ngModel" [(ngModel)]="data.name" placeholder="Player Name" minlength="3" autocomplete="off" />
                    <input type="text" class="form-control form-control-sm" style="max-width: 150px;" id="mobile" name="mobile"
                        #mobile="ngModel" [(ngModel)]="data.mobile" placeholder="Player Mobile" minlength="3" autocomplete="off" />
                    <button type="submit" class="btn btn-primary btn-sm">Search</button>
                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="reset()">Reset</button>
                </form>
            </div>
            <div class="page-section-body">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Active IDs</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let s of searchData" [ngClass]="{'bg-success text-light': s.id === transaction.player_id}">
                            <td>{{s.code}}</td>
                            <td>{{s.name}}</td>
                            <td>{{s.mobile}}</td>
                            <td>{{s.active_player_id_count}}</td>
                            <td class="text-end">
                                <button class="btn btn-sm btn-outline-primary"
                                    *ngIf="s.active_player_id_count > 0 && s.id != transaction.player_id"
                                    (click)="selectPlayer(s)">Claim</button>
                            </td>
                        </tr>
                        <tr *ngIf="searchData.length == 0">
                            <td colspan="5" class="text-center text-muted py-4" style="font-style: italic;">No data available</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Selected Player + Topup -->
        <div class="page-section" *ngIf="transaction.player_id">
            <div class="page-section-header">
                <h2 class="page-section-title">Selected Player</h2>
            </div>
            <div class="page-section-body">
                <table class="table">
                    <tbody>
                        <tr><th>Player Code</th><td>{{transaction.player_code}}</td></tr>
                        <tr><th>Player Name</th><td>{{transaction.player_name}}</td></tr>
                        <tr><th>Player Mobile</th><td>{{transaction.player_mobile}}</td></tr>
                    </tbody>
                </table>
            </div>
            <div class="page-section-form">
                <div class="mb-3">
                    <label class="form-label">Topup to Game (Player ID)</label>
                    <select class="form-select form-select-sm" [(ngModel)]="transaction.player_game_id">
                        <option [value]="''">No</option>
                        <option *ngFor="let pgi of active_player_ids" [value]="pgi.id">{{pgi.game}} ({{pgi.username}}) {{pgi.game_balance}}</option>
                    </select>
                    <p class="text-muted mt-1 mb-0" style="font-size: 11px;">If you don't select a player ID, payment will only be added to the player wallet.</p>
                </div>
                <button type="button" class="btn btn-primary btn-sm w-100" (click)="claim()">Claim Unknown Payment</button>
            </div>
        </div>

    </div>
</div>
